import React from 'react';
import UnauthorizedRoot from './UnauthorizedRoot';
import Root from './Root';

const App = () => localStorage.jwtToken ? <Root /> : <UnauthorizedRoot />

export default App;
